/* CloudFloor theme — lightweight interactions
   No framework. Progressive enhancement only. */
(function () {
  'use strict';

  var on = function (el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var hasFetch = typeof window.fetch === 'function';

  /* ---- Sticky header shadow ---- */
  var header = $('.header');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Toast helper ---- */
  window.CloudFloorToast = function (msg) {
    var t = $('.toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'toast';
      document.body.appendChild(t);
    }
    t.innerHTML = '<i class="fas fa-check-circle"></i> ' + msg;
    t.classList.add('show');
    clearTimeout(window.__cfToast);
    window.__cfToast = setTimeout(function () { t.classList.remove('show'); }, 3200);
  };

  /* ---- Live cart badge ---- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (b) {
      b.textContent = count;
      b.hidden = count === 0;
    });
  }
  function refreshCartCount() {
    if (!hasFetch) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  /* ---- Cart drawer content: rendered server-side via the Ajax Cart API's
     ?sections= param, so prices always come from Liquid's money filter. ---- */
  function renderCartDrawerSections(data) {
    var html = data && data.sections && data.sections['cart-drawer'];
    if (!html) { refreshCartCount(); return; }
    var wrap = $('#CartDrawerContent');
    if (wrap) wrap.innerHTML = html;
    var countEl = wrap ? $('[data-cart-item-count]', wrap) : null;
    var count = countEl ? (parseInt(countEl.textContent, 10) || 0) : 0;
    updateCartCount(count);
    $$('[data-cart-drawer-count]').forEach(function (el) { el.textContent = count > 0 ? '(' + count + ')' : ''; });
  }

  function changeCartLine(line, quantity) {
    if (!hasFetch) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(renderCartDrawerSections)
      .catch(function () { window.location.reload(); });
  }

  /* ---- Drawer / overlay management with scroll lock + focus handling ---- */
  var searchBar = $('.search-bar');
  var mobileMenu = $('.mobile-menu');
  var overlay = $('.overlay');
  var cartDrawer = $('[data-cart-drawer]');
  var lastFocused = null;

  function setExpanded(selector, expanded) {
    $$(selector).forEach(function (b) { b.setAttribute('aria-expanded', String(expanded)); });
  }

  function toggleOverlay() {
    if (!overlay) return;
    var filters = $('.filters');
    var anyOpen = (mobileMenu && mobileMenu.classList.contains('open')) ||
                  (searchBar && searchBar.classList.contains('open')) ||
                  (filters && filters.classList.contains('open')) ||
                  (cartDrawer && cartDrawer.classList.contains('open'));
    overlay.classList.toggle('show', !!anyOpen);
    document.documentElement.classList.toggle('drawer-open', !!anyOpen);
  }

  function closeAll() {
    if (mobileMenu) mobileMenu.classList.remove('open');
    if (searchBar) searchBar.classList.remove('open');
    var f = $('.filters'); if (f) f.classList.remove('open');
    if (cartDrawer) { cartDrawer.classList.remove('open'); cartDrawer.setAttribute('aria-hidden', 'true'); }
    setExpanded('[data-menu-toggle], [data-search-toggle], [data-filters-toggle], [data-cart-toggle]', false);
    toggleOverlay();
    if (lastFocused && typeof lastFocused.focus === 'function') { lastFocused.focus(); lastFocused = null; }
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    lastFocused = document.activeElement;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    setExpanded('[data-cart-toggle]', true);
    toggleOverlay();
    var close = $('[data-cart-drawer-close]', cartDrawer);
    if (close) close.focus();
  }

  $$('[data-cart-toggle]').forEach(function (btn) {
    on(btn, 'click', function (e) { e.preventDefault(); openCartDrawer(); });
  });
  on(document, 'click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-cart-drawer-close]') : null;
    if (t) closeAll();
  });

  /* Quantity +/- and remove inside the drawer (content is re-rendered on every
     change, so this listens on the drawer itself rather than the swapped-out items). */
  on(cartDrawer, 'click', function (e) {
    var qtyBtn = e.target.closest ? e.target.closest('[data-cart-drawer-qty]') : null;
    var removeBtn = e.target.closest ? e.target.closest('[data-cart-drawer-remove]') : null;
    if (!qtyBtn && !removeBtn) return;
    var item = (qtyBtn || removeBtn).closest('[data-cart-drawer-item]');
    var line = item ? parseInt(item.getAttribute('data-line'), 10) : null;
    if (!line) return;
    if (removeBtn) {
      changeCartLine(line, 0);
    } else {
      var valueEl = $('[data-cart-drawer-qty-value]', item);
      var current = valueEl ? (parseInt(valueEl.textContent, 10) || 0) : 0;
      var next = Math.max(0, current + parseInt(qtyBtn.getAttribute('data-cart-drawer-qty'), 10));
      changeCartLine(line, next);
    }
  });

  $$('[data-menu-toggle]').forEach(function (btn) {
    on(btn, 'click', function () {
      if (!mobileMenu) return;
      var opening = !mobileMenu.classList.contains('open');
      if (opening) lastFocused = document.activeElement;
      mobileMenu.classList.toggle('open');
      setExpanded('[data-menu-toggle]', opening);
      toggleOverlay();
      if (opening) { var close = $('.mobile-menu__close'); if (close) close.focus(); }
    });
  });

  $$('[data-search-toggle]').forEach(function (btn) {
    on(btn, 'click', function () {
      if (!searchBar) return;
      var opening = !searchBar.classList.contains('open');
      if (opening) lastFocused = document.activeElement;
      searchBar.classList.toggle('open');
      setExpanded('[data-search-toggle]', opening);
      toggleOverlay();
      if (opening) { var i = $('input', searchBar); if (i) i.focus(); }
      else if (!opening) closeAll();
    });
  });

  $$('[data-filters-toggle]').forEach(function (btn) {
    on(btn, 'click', function () {
      var f = $('.filters');
      if (!f) return;
      var opening = !f.classList.contains('open');
      if (opening) lastFocused = document.activeElement;
      f.classList.toggle('open');
      setExpanded('[data-filters-toggle]', opening);
      toggleOverlay();
    });
  });
  on($('.filters__close'), 'click', closeAll);
  on(overlay, 'click', closeAll);

  on(document, 'keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeAll();
  });

  /* ---- Password show/hide toggle ---- */
  on(document, 'click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-pw-toggle]') : null;
    if (!t) return;
    var wrap = t.closest('.password-wrap') || t.parentNode;
    var inp = wrap ? wrap.querySelector('input') : null;
    if (!inp) return;
    var show = inp.type === 'password';
    inp.type = show ? 'text' : 'password';
    var ic = t.querySelector('i');
    if (ic) ic.className = show ? 'far fa-eye-slash' : 'far fa-eye';
  });

  /* ---- Universal broken-image fallback ---- */
  var placeholderUrl = document.body ? document.body.getAttribute('data-placeholder') : null;
  if (placeholderUrl) {
    document.addEventListener('error', function (e) {
      var img = e.target;
      if (!img || img.tagName !== 'IMG') return;
      if (img.dataset && img.dataset.noFallback !== undefined) return;
      if (img.src.indexOf(placeholderUrl) !== -1) return;
      img.src = placeholderUrl;
      img.srcset = '';
    }, true);
  }

  /* ---- Product gallery (crossfade between images) ---- */
  var reduceMotionGallery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  $$('[data-gallery]').forEach(function (gallery) {
    var mainImg = $('[data-gallery-main]', gallery);
    $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      on(thumb, 'click', function () {
        var full = thumb.getAttribute('data-full');
        if (mainImg && full && full !== mainImg.getAttribute('src')) {
          if (reduceMotionGallery) {
            mainImg.src = full;
            mainImg.srcset = '';
          } else {
            mainImg.classList.add('is-switching');
            setTimeout(function () {
              mainImg.src = full;
              mainImg.srcset = '';
              requestAnimationFrame(function () {
                requestAnimationFrame(function () { mainImg.classList.remove('is-switching'); });
              });
            }, 180);
          }
        }
        $$('[data-gallery-thumb]', gallery).forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('active');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });
  });

  /* ---- Crossfade when switching between sibling products (colour swatches) ----
     Chrome/Edge get this for free via the @view-transition CSS rule in base.css.
     Everywhere else, fade the product photo out before the page navigates so the
     switch reads as one continuous transition rather than an instant page swap. */
  if (typeof document.startViewTransition !== 'function' && !reduceMotionGallery) {
    $$('.pdp-swatch, .product-card__swatch').forEach(function (link) {
      on(link, 'click', function (e) {
        if (link.classList.contains('is-active')) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        var href = link.getAttribute('href');
        if (!href) return;
        var cardOrGallery = link.closest('.gallery') || link.closest('.product-card');
        var img = cardOrGallery ? (cardOrGallery.querySelector('[data-gallery-main]') || cardOrGallery.querySelector('.product-card__img--main')) : null;
        if (!img) return;
        e.preventDefault();
        img.style.transition = 'opacity .22s ease';
        img.style.opacity = '0';
        setTimeout(function () { window.location.href = href; }, 200);
      });
    });
  }

  /* ---- Product detail tabs (with ARIA sync) ---- */

  $$('[data-tabs]').forEach(function (tabWrap) {
    var headers = $$('[data-tab]', tabWrap);
    var panels = $$('[data-tab-panel]', tabWrap);
    headers.forEach(function (h) {
      on(h, 'click', function () {
        var key = h.getAttribute('data-tab');
        headers.forEach(function (x) {
          var active = x === h;
          x.classList.toggle('active', active);
          x.setAttribute('aria-selected', String(active));
          x.tabIndex = active ? 0 : -1;
        });
        panels.forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-tab-panel') === key); });
      });
      on(h, 'keydown', function (e) {
        var idx = headers.indexOf(h);
        var next = null;
        if (e.key === 'ArrowRight') next = headers[(idx + 1) % headers.length];
        else if (e.key === 'ArrowLeft') next = headers[(idx - 1 + headers.length) % headers.length];
        if (next) { e.preventDefault(); next.focus(); next.click(); }
      });
    });
  });

  /* ---- Quantity steppers ---- */
  $$('[data-qty]').forEach(function (wrap) {
    var input = $('input', wrap);
    if (!input) return;
    $$('[data-qty-step]', wrap).forEach(function (btn) {
      on(btn, 'click', function () {
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var val = (parseInt(input.value, 10) || min) + step;
        if (val < min) val = min;
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---- Product grid: fade cards up on first view (Magna-style) ---- */
  (function () {
    if (!window.IntersectionObserver) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    $$('.products-grid, .grid-4').forEach(function (grid) {
      var cards = $$('.product-card', grid).filter(function (c) { return c.parentNode === grid; });
      if (cards.length === 0) return;
      grid.classList.add('cf-reveal');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var idx = cards.indexOf(entry.target);
          entry.target.style.transitionDelay = (Math.min(idx, 7) * 60) + 'ms';
          entry.target.classList.add('cf-in');
          io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
      cards.forEach(function (c) { io.observe(c); });
      // Safety net: never leave a card hidden if the observer misfires.
      setTimeout(function () { cards.forEach(function (c) { c.classList.add('cf-in'); }); }, 2600);
    });
  })();

  /* ---- Collection view toggle (2/3 columns), persisted per-viewer ---- */
  $$('[data-view-toggle]').forEach(function (toggle) {

    var grid = $('[data-products-grid]');
    if (!grid) return;
    $$('button', toggle).forEach(function (btn) {
      on(btn, 'click', function () {
        var cols = btn.getAttribute('data-cols');
        grid.classList.toggle('cols-2', cols === '2');
        $$('button', toggle).forEach(function (b) { b.classList.toggle('active', b === btn); });
        try { localStorage.setItem('cf_grid_cols', cols); } catch (e) {}
      });
    });
    try {
      var saved = localStorage.getItem('cf_grid_cols');
      if (saved) { var b = toggle.querySelector('[data-cols="' + saved + '"]'); if (b) b.click(); }
    } catch (e) {}
  });

  /* ---- Variant picker: keep hidden variant id + price + URL in sync ---- */
  $$('form.product-form, form#product-form').forEach(function (form) {
    if (form.__cfBound) return;
    form.__cfBound = true;
    var jsonEl = $('[data-variant-json]', form);
    if (!jsonEl) return;
    var data = null;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var idInput = $('[data-variant-id]', form) || $('[name="id"]', form);
    if (idInput) idInput.disabled = false; // JS is running: this input is authoritative again
    var priceEl = document.querySelector('[data-product-price]');
    var priceCompareEl = document.querySelector('[data-product-compare-price]');
    var addBtn = $('[data-add-to-cart]', form);
    var addLabel = addBtn ? $('[data-atc-label]', addBtn) : null;
    var addPrice = addBtn ? $('[data-atc-price]', addBtn) : null;

    function currentOptions() {
      return $$('[data-option-index]', form).map(function (group) {
        var picked = $('input:checked', group) || $('select', group);
        return picked ? picked.value : null;
      });
    }

    function match(opts) {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    var optionGroups = $$('[data-option-index]', form);

    function setLabel(text) { if (addLabel) addLabel.textContent = text; else if (addBtn) addBtn.textContent = text; }

    function update() {
      if (optionGroups.length === 0) return; // single-variant product, nothing to sync
      var v = match(currentOptions());
      if (!v) {
        if (addBtn) { addBtn.disabled = true; setLabel(addBtn.getAttribute('data-unavailable') || 'Unavailable'); }
        return;
      }      if (idInput) idInput.value = v.id;
      if (addBtn) {
        addBtn.disabled = !v.available;
        setLabel(v.available ? (addBtn.getAttribute('data-default') || 'Add to Bag')
                              : (addBtn.getAttribute('data-soldout') || 'Sold Out'));
      }
      if (addPrice) addPrice.textContent = v.price_money;
      $$('[data-option-index]', form).forEach(function (group, i) {
        var label = $('[data-option-selected]', group);
        if (label && currentOptions()[i] != null) label.textContent = currentOptions()[i];
      });
      if (priceEl) priceEl.textContent = v.price_money;

      if (priceCompareEl) {
        if (v.compare_at_money) {
          priceCompareEl.textContent = v.compare_at_money;
          priceCompareEl.hidden = false;
          if (priceEl) priceEl.classList.add('sale');
        } else {
          priceCompareEl.hidden = true;
          if (priceEl) priceEl.classList.remove('sale');
        }
      }
      if (history.replaceState && v.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    $$('input, select', form).forEach(function (i) { on(i, 'change', update); });
    update();

  });

  /* ---- AJAX add-to-cart (PDP form + quick-add cards): opens the cart drawer
     as the confirmation, same as the rest of the site's drawer/overlay pattern. ---- */
  function bindAddToCart(form) {
    if (!hasFetch || form.__cfAtcBound) return;
    form.__cfAtcBound = true;
    on(form, 'submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? $('[data-atc-label]', btn) : null;
      var restoreText = label ? label.textContent : (btn ? btn.textContent : '');
      if (btn) { btn.disabled = true; }
      if (label) label.textContent = (btn && btn.getAttribute('data-adding')) || 'Adding…';

      var formData = new FormData(form);
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function (item) {
          renderCartDrawerSections(item);
          openCartDrawer();
        })
        .catch(function (err) {
          var msg = (err && err.description) || 'Could not add to bag. Please try again.';
          window.CloudFloorToast(msg);
        })
        .finally(function () {
          if (btn) btn.disabled = false;
          if (label) label.textContent = restoreText;
        });
    });
  }
  $$('form[action$="/cart/add"]').forEach(bindAddToCart);

  /* ---- AJAX cart quantity updates (debounced) ---- */
  var cartForm = $('#cart');
  if (cartForm && hasFetch) {
    var debounceTimers = {};
    $$('.cart-qty input[name="updates[]"]', cartForm).forEach(function (input) {
      // Replace the native full-page submit with a debounced /cart/change.js call.
      input.removeAttribute('onchange');
      on(input, 'change', function () {
        var line = input.getAttribute('data-line');
        clearTimeout(debounceTimers[line]);
        debounceTimers[line] = setTimeout(function () {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: Number(line), quantity: Number(input.value) })
          })
            .then(function (r) { return r.json(); })
            .then(function () { window.location.reload(); })
            .catch(function () { input.form.submit(); });
        }, 350);
      });
    });
  }

  /* ---- Newsletter inline success (Shopify handles the POST) ---- */
  if (window.location.search.indexOf('customer_posted=true') !== -1) {
    var ok = $('.newsletter-success');
    if (ok) ok.hidden = false;
  }

  /* ---- Help Centre: tabbed panels (one section-group visible at a time) ---- */
  var helpTabs = $('[data-help-tabs]');
  if (helpTabs) {
    var htabs = $$('[data-help-tab]', helpTabs);
    var panelSets = htabs.map(function (t) {
      return (t.getAttribute('data-help-tab') || '').split(',')
        .map(function (k) { return document.getElementById('shopify-section-' + k.trim()); })
        .filter(Boolean);
    });
    var allHelpPanels = [];
    panelSets.forEach(function (set) {
      set.forEach(function (p) {
        p.classList.add('help-panel');
        if (allHelpPanels.indexOf(p) === -1) allHelpPanels.push(p);
      });
    });
    var activateHelpTab = function (idx) {
      htabs.forEach(function (t, i) {
        var isOn = i === idx;
        t.classList.toggle('active', isOn);
        t.setAttribute('aria-selected', String(isOn));
      });
      allHelpPanels.forEach(function (p) { p.hidden = true; });
      (panelSets[idx] || []).forEach(function (p) { p.hidden = false; });
    };
    htabs.forEach(function (t, i) {
      on(t, 'click', function () { activateHelpTab(i); });
      on(t, 'keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = htabs[(i + 1) % htabs.length];
        else if (e.key === 'ArrowLeft') next = htabs[(i - 1 + htabs.length) % htabs.length];
        if (next) { e.preventDefault(); next.focus(); next.click(); }
      });
    });
    activateHelpTab(0);
  }

  /* ---- Testimonial carousel: 2-up desktop / 1-up mobile, autoplay + swipe ---- */
  $$('[data-testimonial-carousel]').forEach(function (carousel) {
    var wrap = carousel.closest('.container') || carousel.parentNode;
    var viewport = $('[data-carousel-viewport]', carousel);
    var track = $('[data-carousel-track]', carousel);
    var slides = $$('[data-carousel-slide]', track);
    var prevBtn = $('[data-carousel-prev]', carousel);
    var nextBtn = $('[data-carousel-next]', carousel);
    var dotsWrap = $('[data-carousel-dots]', wrap);
    if (!track || !viewport || slides.length === 0) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var GAP = 24;
    var perView = 1;
    var page = 0;
    var pageCount = 1;
    var autoplayId = null;
    var AUTOPLAY_MS = 3000;

    function computePerView() { return window.innerWidth < 769 ? 1 : 2; }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pageCount; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'carousel-dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Show reviews, page ' + (i + 1) + ' of ' + pageCount);
        (function (idx) { on(b, 'click', function () { goTo(idx); restartAutoplay(); }); })(i);
        dotsWrap.appendChild(b);
      }
      updateDots();
    }

    function updateDots() {
      if (!dotsWrap) return;
      $$('.carousel-dot', dotsWrap).forEach(function (d, i) { d.classList.toggle('active', i === page); });
    }

    function layout() {
      perView = computePerView();
      var vpWidth = viewport.clientWidth;
      var slideWidth = (vpWidth - GAP * (perView - 1)) / perView;
      slides.forEach(function (s) { s.style.width = slideWidth + 'px'; });
      pageCount = Math.max(1, Math.ceil(slides.length / perView));
      if (page > pageCount - 1) page = pageCount - 1;
      buildDots();
      render(true);
      if (prevBtn) prevBtn.disabled = pageCount <= 1;
      if (nextBtn) nextBtn.disabled = pageCount <= 1;
    }

    function render(instant) {
      var vpWidth = viewport.clientWidth;
      track.style.transition = instant ? 'none' : '';
      track.style.transform = 'translateX(-' + (page * (vpWidth + GAP)) + 'px)';
      if (instant) { void track.offsetHeight; track.style.transition = ''; }
      updateDots();
    }

    function goTo(p) {
      if (pageCount <= 1) return;
      page = ((p % pageCount) + pageCount) % pageCount;
      render(false);
    }

    function startAutoplay() {
      if (reduceMotion || pageCount <= 1) return;
      stopAutoplay();
      autoplayId = setInterval(function () { goTo(page + 1); }, AUTOPLAY_MS);
    }
    function stopAutoplay() { if (autoplayId) { clearInterval(autoplayId); autoplayId = null; } }
    function restartAutoplay() { stopAutoplay(); startAutoplay(); }

    on(prevBtn, 'click', function () { goTo(page - 1); restartAutoplay(); });
    on(nextBtn, 'click', function () { goTo(page + 1); restartAutoplay(); });
    on(carousel, 'mouseenter', stopAutoplay);
    on(carousel, 'mouseleave', startAutoplay);
    on(carousel, 'focusin', stopAutoplay);
    on(carousel, 'focusout', startAutoplay);

    /* Touch swipe */
    var touchStartX = null;
    on(track, 'touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      stopAutoplay();
    }, { passive: true });
    on(track, 'touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) { dx < 0 ? goTo(page + 1) : goTo(page - 1); }
      touchStartX = null;
      startAutoplay();
    });

    var resizeTimer = null;
    on(window, 'resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layout, 150);
    });

    layout();
    startAutoplay();
  });
})();
